// Initialisation
function tooltip() {
    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover'
    });
}
tooltip();

export { tooltip };
